import { createSlice } from "@reduxjs/toolkit";
import {
  AnyStatusData,
  AnyStatusInitialStatus,
} from "../../../types/status/status";
import { updateAnyStatusAsync } from "./anyStatus.Api";

const initialState: AnyStatusInitialStatus<AnyStatusData> = {
  loading: false,
  manageLoading: false,
  anyStatus: [],
};

const anyStatusSlice = createSlice({
  name: "admin-status",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    // update
    builder
      .addCase(updateAnyStatusAsync.pending, (state) => {
        state.manageLoading = true;
      })
      .addCase(updateAnyStatusAsync.fulfilled, (state) => {
        state.manageLoading = false;
      })
      .addCase(updateAnyStatusAsync.rejected, (state) => {
        state.manageLoading = false;
      });
  },
});

export default anyStatusSlice;
